import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";

@Component({
    selector: "woa-card-brand",
    templateUrl: "./card-brand.component.html",
})
export class CardBrandComponent implements OnChanges {
    @Input() brand: string;
    @Input() cardNumber: string;

    get upperCaseBrand(): string {
        return this.brand ? this.brand.toUpperCase() : undefined;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["cardNumber"]) {
            this.evaluateBrand();
        }
    }

    evaluateBrand(): void {
        if (this.cardNumber) {
            if (this.cardNumber.startsWith("5")) {
                this.brand = "mastercard";
            } else if (this.cardNumber.startsWith("4")) {
                this.brand = "visa";
            } else if (this.cardNumber.startsWith("34") || this.cardNumber.startsWith("37")) {
                this.brand = "amex";
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/card-brand/card-brand.component.ts